module.exports = __webpack_public_path__ + "static/media/PDF_104.91aeeb81.pdf";